import { escape, BRAND, buildSponsorStrip } from "./reelShared";

/**
 * Landscape share reel — 1200×630.
 * Sized for X/Twitter, Facebook, LinkedIn in-feed and OpenGraph previews.
 */
export const buildShareCardSVG = ({ user, color, tierShort, tierCap, memberNumber, sponsor }) => {
    const w = 1200;
    const h = 630;
    const metrics = [
        { label: "TREES RESTORED", value: user.trees_restored, color },
        { label: "LBS OCEAN PLASTIC", value: user.ocean_plastic_lbs, color: BRAND.ocean },
        { label: "BATTERIES PROTECTED", value: user.batteries_protected, color: BRAND.violet },
        { label: "CO₂ PREVENTED (LBS)", value: user.co2_saved_lbs.toLocaleString(), color: BRAND.solar },
    ];
    const metricsSvg = metrics
        .map(
            (m, i) => `
      <g transform="translate(${i * 268} 0)">
        <rect x="0" y="0" width="248" height="140" rx="8" fill="#0a0a0a" stroke="${BRAND.line}"/>
        <circle cx="20" cy="24" r="4" fill="${m.color}"/>
        <text x="34" y="30" fill="${BRAND.inkDim}" font-family="'Helvetica Neue', Arial, sans-serif" font-size="10" font-weight="700" letter-spacing="3">${escape(m.label)}</text>
        <text x="20" y="100" fill="${BRAND.ink}" font-family="'Menlo', 'Courier New', monospace" font-size="48" font-weight="800">${escape(m.value)}</text>
      </g>`
        )
        .join("");

    const footerY = sponsor ? 490 : 580;
    const sponsorSvg = sponsor ? buildSponsorStrip({ sponsor, cx: w / 2, y: 540, color }) : "";
    const brandFooter = `<text x="64" y="${footerY}" fill="${BRAND.inkFaint}" font-family="'Helvetica Neue', Arial, sans-serif" font-size="14" letter-spacing="4">POWERED BY THE EVIQ COMMUNITY · eviq.app</text>`;

    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${w} ${h}" role="img" aria-label="EVIQ impact share reel">
  <defs>
    <linearGradient id="sc-bg" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" stop-color="${BRAND.bgTop}"/>
      <stop offset="100%" stop-color="${BRAND.bgBottom}"/>
    </linearGradient>
    <radialGradient id="sc-glow" cx="80%" cy="20%" r="60%">
      <stop offset="0%" stop-color="${color}" stop-opacity="0.28"/>
      <stop offset="100%" stop-color="${color}" stop-opacity="0"/>
    </radialGradient>
  </defs>
  <rect width="${w}" height="${h}" fill="url(#sc-bg)"/>
  <rect width="${w}" height="${h}" fill="url(#sc-glow)"/>
  <rect x="1" y="1" width="${w - 2}" height="${h - 2}" fill="none" stroke="${BRAND.line}" stroke-width="2"/>
  <g transform="translate(64 64)">
    <rect x="0" y="0" width="36" height="36" rx="6" fill="#0a0a0a" stroke="#27272a"/>
    <path d="M 12 8 L 22 8 L 18 18 L 24 18 L 14 32 L 18 20 L 10 20 Z" fill="${color}"/>
    <text x="52" y="14" fill="${BRAND.inkDim}" font-family="'Helvetica Neue', Arial, sans-serif" font-size="11" font-weight="600" letter-spacing="4">EVIQ</text>
    <text x="52" y="30" fill="${BRAND.ink}" font-family="Georgia, serif" font-style="italic" font-size="18">Earth Initiative</text>
  </g>
  <g transform="translate(1000 88)">
    <rect x="-160" y="-30" width="160" height="60" rx="30" fill="${color}" fill-opacity="0.14" stroke="${color}"/>
    <text x="-80" y="-6" text-anchor="middle" fill="${color}" font-family="'Helvetica Neue', Arial, sans-serif" font-size="10" font-weight="700" letter-spacing="4">${escape(tierCap)}</text>
    <text x="-80" y="18" text-anchor="middle" fill="${color}" font-family="'Helvetica Neue', Arial, sans-serif" font-size="18" font-weight="800" letter-spacing="2">${escape(tierShort)} #${escape(memberNumber)}</text>
  </g>
  <text x="64" y="220" fill="${BRAND.ink}" font-family="Georgia, serif" font-size="66" font-weight="700">I'm helping restore</text>
  <text x="64" y="292" fill="${BRAND.inkDim}" font-family="Georgia, serif" font-size="66" font-style="italic">the planet with EVIQ.</text>
  <g transform="translate(64 380)">${metricsSvg}</g>
  ${sponsorSvg}
  ${brandFooter}
</svg>`;
};
